function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dataops_service from '@/apps/dataops/services/dataops_service';
import { localPaginationMixin } from '@/mixins/local_pagination';
import { mapMutations } from 'vuex';
import { filterMixin } from '@/mixins/filter_mixin';
import { useCaseListMixin } from '@/apps/attributes/mixins/use_case_list_mixin';
export default {
  name: 'Orchestrator',
  mixins: [filterMixin, localPaginationMixin, useCaseListMixin],
  data: function data() {
    return {
      rawData: [],
      tasks: [],
      form: {
        date: new Date().toISOString().substr(0, 10)
      },
      max_date: new Date().toISOString().substr(0, 10),
      processedData: [],
      selectedItem: null,
      selectionType: 'leaf',
      date: new Date().toISOString().substr(0, 10),
      menu: false
    };
  },
  mounted: function mounted() {
    this.buscar();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    openDialog: function openDialog(item) {
      this.selectedItem = item;
    },
    buscar: function buscar() {
      var _this = this;
      this.setShowLoading(true);
      var date = this.date;
      dataops_service.executionsList(date).then(function (response) {
        _this.setShowLoading(false);
        if (response.status_code === 200) {
          _this.rawData = response.data;
          _this.organizarParaVTreeView(_this.rawData);
          _this.tasks = [];
          _this.rawData.forEach(function (item) {
            item.tasks.forEach(function (task) {
              _this.tasks.push(task);
            });
          });
        }
      }).catch(function (error) {
        _this.setShowLoading(false);
        console.log(error);
      });
    },
    organizarParaVTreeView: function organizarParaVTreeView(rawData) {
      var _this2 = this;
      this.rawData.forEach(function (item) {
        item.tasks.forEach(function (task) {
          task.uniqueKey = item.id + '_' + task.taskID;
          task.group = item.id;
        });
      });
      var hijo = [];
      this.rawData.forEach(function (item) {
        var rootTasks = item.tasks.filter(function (t) {
          return t.parentID === -1;
        });
        var organizedTasks = rootTasks.map(function (task) {
          return _this2.organizarTarea(task, item.tasks);
        });
        hijo.push({
          id: item.id,
          jobName: item.jobName,
          parentID: item.parentID,
          children: organizedTasks,
          state: item.state,
          startTime: item.startTime,
          endTime: item.endTime,
          versionName: item.versionName,
          taskID: item.taskID,
          message: item.message
        });
      });
      // GRAN PADRE
      var granPadre = [];
      var c = 1;
      hijo.forEach(function (item) {
        if (!granPadre.find(function (t) {
          return t.jobName === item.jobName;
        })) {
          granPadre.push({
            id: c,
            jobName: item.jobName,
            children: hijo.filter(function (t) {
              return t.jobName === item.jobName;
            }),
            state: item.state,
            startTime: item.startTime,
            endTime: item.endTime,
            version: item.versionName,
            taskID: item.taskID
          });
          c++;
        }
      });
      this.processedData = granPadre;
    },
    organizarTarea: function organizarTarea(tarea, todasLasTareas) {
      var _this3 = this;
      var children = todasLasTareas.filter(function (t) {
        return t.parentID === tarea.taskID;
      });
      if (children.length > 0) {
        return _objectSpread(_objectSpread({}, tarea), {}, {
          id: tarea.uniqueKey,
          group: tarea.group,
          jobName: tarea.jobName,
          componentName: tarea.componentName,
          children: children.map(function (t) {
            return _this3.organizarTarea(t, todasLasTareas);
          })
        });
      }
      return tarea;
    },
    formatTime: function formatTime(timestamp) {
      var date = new Date(timestamp);
      return date.toLocaleTimeString('es-ES', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },
    calcularTiempoTranscurrido: function calcularTiempoTranscurrido(startTime, endTime) {
      var diferencia = endTime - startTime;
      var segundos = Math.floor(diferencia / 1000 % 60);
      var minutos = Math.floor(diferencia / (1000 * 60) % 60);
      var horas = Math.floor(diferencia / (1000 * 60 * 60) % 24);
      var resultado = '';
      if (horas > 0) {
        resultado += "".concat(horas, "h");
      }
      if (minutos > 0) {
        resultado += "".concat(minutos, "m ");
      }
      if (segundos > 0) {
        resultado += "".concat(segundos, "s");
      }
      return resultado.trim();
    },
    calcularPorcentaje: function calcularPorcentaje(startTime, endTime) {
      // Asegurar que el valor máximo no sea cero para evitar división por cero
      if (endTime - startTime === 0) {
        return 0;
      }
      return (endTime - startTime) * 100 / 1000000;
    },
    obtenerNombreComponentePadre: function obtenerNombreComponentePadre(children) {
      console.log(children, 'children');
      console.log(this.tasks, 'this.tasks');
      var padre = this.tasks.find(function (item) {
        return item.taskID === children.parentID && item.group === children.group;
      });
      return padre ? padre.jobName : 'Desconocido';
    }
  }),
  computed: {}
};